import React, { useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import Icon from '../AppIcon';
import Button from './Button';

const LanguageSwitcher = ({ showLabels = false, variant = "ghost" }) => {
  const { currentLanguage, supportedLanguages, changeLanguage, isLoading, getCurrentLanguageData } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  
  const currentLang = getCurrentLanguageData();

  const handleLanguageChange = async (languageCode) => {
    await changeLanguage(languageCode);
    setIsOpen(false);
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="relative">
      <Button
        variant={variant}
        size="sm"
        onClick={toggleDropdown}
        disabled={isLoading}
        className="flex items-center space-x-2"
      >
        <span className="text-lg">{currentLang?.flag}</span>
        {showLabels && (
          <span className="hidden sm:inline text-sm font-medium">
            {currentLang?.name}
          </span>
        )}
        <Icon 
          name={isLoading ? "Loader2" : "ChevronDown"} 
          size={14} 
          className={isLoading ? "animate-spin" : ""}
        />
      </Button>

      {isOpen && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 z-40"
            onClick={() => setIsOpen(false)}
          />
          
          {/* Dropdown */}
          <div className="absolute right-0 mt-2 w-56 bg-popover border border-border rounded-lg shadow-warm-lg z-50">
            <div className="p-2 max-h-64 overflow-y-auto">
              <div className="px-3 py-2 text-sm font-medium text-muted-foreground border-b border-border mb-2">
                Select Language
              </div>
              
              {supportedLanguages?.map((language) => (
                <button
                  key={language?.code}
                  onClick={() => handleLanguageChange(language?.code)}
                  disabled={isLoading}
                  className={`flex items-center space-x-3 w-full px-3 py-2 text-sm rounded-md transition-warm ${
                    currentLanguage === language?.code
                      ? 'bg-primary text-primary-foreground'
                      : 'text-foreground hover:bg-muted'
                  } ${isLoading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                >
                  <span className="text-lg">{language?.flag}</span>
                  <span className="flex-1 text-left">{language?.name}</span>
                  {currentLanguage === language?.code && (
                    <Icon name="Check" size={16} />
                  )}
                </button>
              ))}
            </div>
            
            <div className="border-t border-border p-2">
              <div className="text-xs text-muted-foreground px-3 py-1">
                Language settings are saved automatically
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default LanguageSwitcher;